import { AgxTenantedPropertyDetails } from '@urbanx/agx-ui-components'
import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2'
import Panel from 'components/panel/Panel'
import { TenantedPropertyDetailsModel } from '@urbanx/agx.campaigns.client'

interface TenancyInformationSectionProps {
  tenancyInformation?: TenantedPropertyDetailsModel | undefined
  setTenancyInformation: (
    value: TenantedPropertyDetailsModel | undefined
  ) => void
  hasUnsavedChanges: boolean
}

const TenancyInformationSection = ({
  tenancyInformation,
  setTenancyInformation,
  hasUnsavedChanges,
}: TenancyInformationSectionProps) => {
  return (
    <AgxSpacer
      id="tenancy-information"
      direction="vertical"
      gap="spacing-xl"
      fill
    >
      <Panel
        title={
          <AgxTypography id="tenancyInformationTitle" type="body" size="medium">
            Tenancy Information
          </AgxTypography>
        }
        padding={{
          top: 'md',
          bottom: 'md',
          left: 'xl',
          right: 'xl',
        }}
      >
        <AgxSpacer direction="vertical" gap="spacing-xl" fill>
          <AgxTenantedPropertyDetails
            key={`TenancyInformation-${tenancyInformation?.tenancyType}`}
            id="tenancyInformationDetails"
            label="Tenancies *"
            defaultValue={{
              tenancyType: tenancyInformation?.tenancyType,
              address: tenancyInformation?.address,
              agencyEmail: tenancyInformation?.agencyEmail,
              agencyName: tenancyInformation?.agencyName,
              agencyPhone: tenancyInformation?.agencyPhone,
              contactName: tenancyInformation?.contactName,
              previousTenancyDetails:
                tenancyInformation?.previousTenancyDetails,
            }}
            onValueUpdated={({ value }) =>
              setTenancyInformation({
                tenancyType: value.tenancyType,
                address: value.address,
                agencyEmail: value.agencyEmail,
                agencyName: value.agencyName,
                agencyPhone: value.agencyPhone,
                contactName: value.contactName,
                previousTenancyDetails: value.previousTenancyDetails,
              })
            }
            required
            validate={hasUnsavedChanges}
            isManagingAgentEmailRequired
            isManagingAgentNameRequired
            showPreviousTenancyDetails={false}
            showHolidayRentalOption={false}
            noDefaultValueCheck={false}
            lastRentIncreaseRequired={false}
          />
        </AgxSpacer>
      </Panel>
    </AgxSpacer>
  )
}

export default TenancyInformationSection
